import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import { exportReportText } from 'Const/report-help-partner/domain';
import { useLoader } from 'Store/loader';
import getExportReportHelpPartner from 'Api/report-help-partner/getExportReportHelpPartner';

import getExportGetReportHelpPartner from './model/request/getExportGetReportHelpPartner';

const useExportGetReportHelpPartner = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async (filter) => {
      onShowLoader({ variant: 'loader-primary' });

      const params = getExportGetReportHelpPartner(filter);

      const response = await getExportReportHelpPartner(params);

      return response;
    },
    onSuccess: (response) => {
      const filename = `Report Help Partner.xlsx`;

      const blob = new Blob([response]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportReportText.successExportText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportReportText.failedExportText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useExportGetReportHelpPartner;
